module.exports = __webpack_public_path__ + "img/login_pc.5dc09ab2.png";